import { InfiniteScroll } from "nq-component";
import RequestPresenter from "./RequestPresenter";
import BaseListPage from "../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import CardView from "../../components/common/CardView";
import Table from "../../components/Table";
import withRouter from "../../withRouter";
import ServiceRequestForm from "./service-request-form/ServiceRequestForm";
import NavBar from "../../components/navigation";
import Progress from "../../components/Progress";

class RequestPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new RequestPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = { objects: [], count: 0, limit: 10, current: 1 };
  }

  getCollectionName() {
    return "requests";
  }

  // delete function
  // async handleDeleteData(id) {
  //   await this.presenter.deleteObjectUseCase.execute("requests", id);
  //   this.refetchData();
  // }

  // edit function
  async handleEditData(object) {
    this.navigateTo(`/view/${this.getCollectionName()}/${object.id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  currentUser() {
    return this.getCurrentUser();
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, limit, count } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    console.log("OBJ: ", objects);
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.collection}
                  </span>
                </p>
              </div>

              <ServiceRequestForm refetchData={this.refetchData.bind(this)} />

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-start">
                    <h4 className="text-primary">{schema.collection}</h4>
                  </div>
                </CardView>
              </div>

              <Table
                // objectId={this.handleDeleteData.bind(this)}
                objectData={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "Created At",
                    "Updated At",
                    "description",
                    "workFlow",
                    "taskIndex",
                  ]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(RequestPage);
